import { useState } from "react";

export default function useStepper<T extends { id: string }>({ steps, onNext, onPrevious }: Props<T>) {
  // here we use an object, so each 'set' will create a new reference and retrigger
  // the useEffect even if it's the same value
  const [stepIndex, setStepIndex] = useState<{ index: number }>({ index: 0 });

  // in case we show scroller this will be undefined so we don't see the button
  const previous = () => {
    const current = stepIndex.index;
    const target = Math.max(0, current - 1);
    setStepIndex({ index: target });
    onPrevious?.(current, target);
  };

  const next = (from?: number) => {
    const current = stepIndex.index;
    const target = from !== undefined ? from + 1 : Math.min(steps.length - 1, current + 1);
    setStepIndex({ index: target });
    onNext?.(current, target);
  };

  const currentStep = steps[Math.max(0, Math.min(stepIndex.index, steps.length - 1))]!;
  const currentStepIndex = steps.findIndex(s => s.id === currentStep.id); // TODO FIXME: currentStepIndex is calculated just above

  console.log("stepper: ", {
    stepIndex,
    currentStepIndex,
    currentStep,
  });

  // TODO: sync w/ history navigation

  return { stepIndex, currentStep, currentStepIndex, next, previous, setStepIndex };
}

interface Props<T extends { id: string }> {
  steps: Array<T>;
  onNext?: (current: number, target: number) => void;
  onPrevious?: (current: number, target: number) => void;
}
